

































import Vue from 'vue'
import { TransferLogServiceProxy } from '@/service-proxies/app-v2/dnc.service-proxies'
import dayjs from 'dayjs'

const transferLogServiceProxy = new TransferLogServiceProxy()
export default Vue.extend({
  name: 'TransportLogTable',
  props: {
    transferId: { // 工位文件的id
      type: String,
      default: ''
    }
  },
  data() {
    return {
      data: [],
      loading: false,
      pagination: {
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
        pageSize: 30,
        current: 1
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('page_transport_directory_operation_type'),
          dataIndex: 'operation',
          key: 'operation',
          width: 80,
          customRender: (text,record) => {
            if(record.id) {
              let value = ''
              switch (text.toUpperCase()) {
                case 'DELETE':
                  value =  this.$t('delete')
                  break
                case 'POST':
                  value =  this.$t('save')
                  break
                case 'FTP_POST':
                  value =  this.$t('page_transport_directory_ftp_post')
                  break
              }
              return value
            }
            else {
              return ''
            }
          },
        },
        {
          title: this.$t('page_transport_directory_message_type'),
          dataIndex: 'messageType',
          key: 'messageType',
          width: 100,
          scopedSlots: { customRender: 'messageType' }
        },
        {
          title: this.$t('page_transport_directory_resource_name'),
          dataIndex: 'resourceName',
          key: 'resourceName',
          width: 100
        },
        {
          title: this.$t('page_transport_directory_resource_version_name'),
          dataIndex: 'versionName',
          key: 'versionName',
          width: 100
        },
        {
          title: this.$t('page_transport_directory_operator'),
          dataIndex: 'operateName',
          key: 'operateName',
          width: 70
        },
        {
          title: this.$t('page_transport_directory_operation_time'),
          dataIndex: 'operateTime',
          key: 'operateTime',
          width: 130,
          scopedSlots: { customRender: 'operateTime' }
        }
      ]
    }
  },
  watch: {
    transferId: {
      handler() {
        this.pagination.total = 0
        this.pagination.pageSize = 30
        this.pagination.current = 1
        this.getTableData()
      },
      immediate: true
    }
  },
  methods: {
    formatData(val) {
      if(val === '' || val == null) {
        return ''
      }
      else {
        return dayjs(val).format('YYYY-MM-DD HH:mm:ss')
      }
      
    },
    // 更改目录，或目录下执行了文件增删时重新加载
    async getTableData() {
      this.data = []
      if (!this.transferId) {
        return
      }
      this.loading = true
      try {
        let { records, total } = await transferLogServiceProxy.getPageByTransfer(this.pagination.current,  this.pagination.pageSize, this.transferId)
        // this.data = records


        let dataLength = records.length;
        let copy = JSON.parse(JSON.stringify(records));
        let needPush = 0;
        if(dataLength < 30) {
          needPush = 30 - dataLength;
          for(var k=0; k<needPush; k++) {
            let obj = {  
              // id: 'none'
              operateTime: ''
            }
            copy.push(obj)  
          }
        }

        this.data = JSON.parse(JSON.stringify(copy));


        this.pagination.total = (total)
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    showTotal(total){
      return (this.$t('Total…items') as string).replace('{0}', total)
    },
    handleTableChange(current: number, pageSize: number) {
      const pager = {
        pageSize: pageSize,
        current: current
      }
      Object.assign(this.pagination, pager)
      this.getTableData()
    }
  }
})
